import moment from 'moment';

const TIMESTAMP_FORMATS = [
  'DD/MM/YYYY HH:mm:ss',
  'DD/MM/YYYY HH:mm',
  moment.ISO_8601,
];

export const parseAuditTimestamp = (timestamp) => {
  if (!timestamp) return null;
  const parsed = moment(timestamp, TIMESTAMP_FORMATS, true);
  if (parsed.isValid()) return parsed;
  const loose = moment(timestamp);
  return loose.isValid() ? loose : null;
};

export const formatAuditTimestamp = (timestamp) => {
  const parsed = parseAuditTimestamp(timestamp);
  if (parsed) return parsed.format('DD/MM/YYYY HH:mm');
  return timestamp || '—';
};

export const formatAuditTimeOnly = (timestamp) => {
  const parsed = parseAuditTimestamp(timestamp);
  if (parsed) return parsed.format('HH:mm:ss');
  if (timestamp && String(timestamp).includes(' ')) {
    return String(timestamp).split(' ').slice(1).join(' ') || timestamp;
  }
  return timestamp || '—';
};

export const formatAuditDateGroup = (timestamp) => {
  const parsed = parseAuditTimestamp(timestamp);
  if (parsed) return parsed.format('DD MMM YYYY').toUpperCase();
  if (timestamp && String(timestamp).includes(' ')) {
    return String(timestamp).split(' ')[0];
  }
  return timestamp || '—';
};

export const getAuditActor = (item) => item?.username || '—';

/** Linhas de alteração — usa `fields[]` do backend (qualquer quantidade); sem parse de `message`. */
export const getAuditFieldLines = (item) => {
  const fields = item?.fields;
  if (!Array.isArray(fields)) return [];
  return fields.map((line) => String(line).trim()).filter(Boolean);
};

export const compareAuditByTimestampDesc = (a, b) => {
  const aParsed = parseAuditTimestamp(a?.timestamp);
  const bParsed = parseAuditTimestamp(b?.timestamp);
  if (aParsed && bParsed) return bParsed.valueOf() - aParsed.valueOf();
  if (aParsed) return -1;
  if (bParsed) return 1;
  return String(b?.timestamp || '').localeCompare(String(a?.timestamp || ''));
};

export const groupHistoricoByDate = (items) => {
  const groups = [];
  let currentKey = null;

  items.forEach((item, index) => {
    const dateKey = formatAuditDateGroup(item.timestamp);
    if (dateKey !== currentKey) {
      currentKey = dateKey;
      groups.push({ type: 'date', key: `date-${dateKey}-${index}`, label: dateKey });
    }
    groups.push({ type: 'item', key: `item-${index}-${item.timestamp}-${item.username}`, item });
  });

  return groups;
};
